import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";

type NoteIconProps = Partial<SVGIconProps>;
const NoteIcon = (props: NoteIconProps) => {
  return (
    <SVGIcon fill="none" viewBox="0 0 17 16" {...props}>
      <path
        d="M15.1668 6.66665V9.99998C15.1668 13.3333 13.8335 14.6666 10.5002 14.6666H6.50016C3.16683 14.6666 1.8335 13.3333 1.8335 9.99998V5.99998C1.8335 2.66665 3.16683 1.33331 6.50016 1.33331H9.8335"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1668 6.66665H12.5002C10.5002 6.66665 9.8335 5.99998 9.8335 3.99998V1.33331L15.1668 6.66665Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1665 8.66669H9.1665"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1665 11.3333H7.83317"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGIcon>
  );
};

export default NoteIcon;
